/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import ThreeDotsLoader from '../../Components/LoadingDots';

function DeleteBannerModal({
    deleteBannermodal, setDeleteBannerModal, handleDeletePromotion, item, setThreeDotsLoader, threeDotLoader,
}) {
    return (
        <div className={`modal fade fixed top-0 left-0 ${deleteBannermodal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="deleteUserModal" data-testid="delete-banner-modal" tabIndex="-1" aria-labelledby="activateUserModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Delete Banner
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setDeleteBannerModal(false)}
                        />
                    </div>
                    <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                        <p className="text-xs6 font-normal text-[#555259]">
                            Are you sure you want to delete "
                            {item.title}
                            "?
                        </p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap mx-auto pb-6 rounded-b-md">
                        <button
                            type="button"
                            className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] w-[158px] h-12 rounded-lg"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setDeleteBannerModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="border border-[#673593] ml-5 bg-[#555259] text-base font-normal text-[#ffffff] w-[158px] h-12 rounded-lg delete-banner"
                            data-testid="delete-banner-confirm-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => handleDeletePromotion(item.promotion_id)}
                        >
                            {threeDotLoader ? <div className="ml-[64px]"><ThreeDotsLoader /></div> : 'Yes'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteBannerModal;
